import React, { Component } from 'react'
import {
    Alert,
    Button,
    Card,
    Drawer,
    Empty,
    Input,
    Modal,
    Pagination,
    Radio,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tabs,
    Tag,
    Typography,
    message,
} from 'antd'
import {
    AuditOutlined,
    CopyOutlined,
    LockOutlined,
    ReloadOutlined,
    SafetyCertificateOutlined,
    SearchOutlined,
} from '@ant-design/icons'
import {
    getUserDeparts,
    getUserListForDropbox,
    getVibeAppList,
    getVibePageAccessAudit,
    getVibePageAccessRoutes,
    saveVibeAppAccessType,
    saveVibeAppPortalVisible,
    saveVibePagePermission,
} from '../../request'
import './index.less'

const { Text, Title } = Typography
const { TabPane } = Tabs

const STATUS_META = {
    ready: { color: 'success', text: '运行中' },
    provisioning: { color: 'processing', text: '接入中' },
    approved: { color: 'blue', text: '待接入' },
    failed: { color: 'error', text: '接入失败' },
    disabled: { color: 'default', text: '已停用' },
}

const SUBJECT_META = {
    ALL: { color: 'blue', text: '全部员工' },
    USER: { color: 'green', text: '员工' },
    DEPARTMENT: { color: 'purple', text: '部门' },
}

export default class VibePageAccess extends Component {
    state = {
        loading: false,
        listError: '',
        apps: [],
        total: 0,
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        status: undefined,
        accessSavingId: null,
        portalSavingIds: [],

        drawerVisible: false,
        selectedProject: null,
        routeLoading: false,
        routeError: '',
        routes: [],
        routeSyncPrompt: '',
        selectedRouteIds: [],
        subjectType: 'ALL',
        subjectId: undefined,
        includeChildren: true,
        permissionSaving: false,
        users: [],
        departments: [],
        optionLoading: false,
        optionError: '',

        auditLoaded: false,
        auditLoading: false,
        auditError: '',
        audits: [],
        auditTotal: 0,
        auditPageNum: 1,
        auditPageSize: 20,
    }

    componentDidMount() {
        const search = new URLSearchParams(this.props.location?.search || '')
        const projectId = search.get('projectId')
        const keyword = search.get('keyword') || ''
        this.pendingProjectId = /^\d+$/.test(projectId || '') ? projectId : null
        if (keyword) {
            this.setState({ keyword, pageNum: 1 }, this.loadApps)
            return
        }
        this.loadApps()
    }

    normalizePage = (result) => {
        if (Array.isArray(result)) return { list: result, total: result.length }
        return {
            list: result?.list || result?.records || [],
            total: result?.total || 0,
        }
    }

    loadApps = async () => {
        const { pageNum, pageSize, keyword, status } = this.state
        this.setState({ loading: true, listError: '' })
        try {
            const result = await getVibeAppList({ pageNum, pageSize, keyword, status })
            const page = this.normalizePage(result)
            const selectedProject = this.pendingProjectId
                ? page.list.find(project => String(project.id) === this.pendingProjectId)
                : null
            this.pendingProjectId = null
            this.setState({ apps: page.list, total: page.total, loading: false }, () => {
                if (selectedProject) {
                    this.openPermissionDrawer(selectedProject)
                }
            })
        } catch (error) {
            this.setState({ loading: false, listError: error?.message || '应用列表加载失败' })
        }
    }

    resetSearch = () => {
        this.setState({ keyword: '', status: undefined, pageNum: 1 }, this.loadApps)
    }

    changeAccessType = async (project, accessType) => {
        this.setState({ accessSavingId: project.id })
        try {
            await saveVibeAppAccessType({ projectId: project.id, accessType })
            this.setState(({ apps, selectedProject }) => ({
                apps: apps.map(item => item.id === project.id ? { ...item, accessType } : item),
                selectedProject: selectedProject?.id === project.id
                    ? { ...selectedProject, accessType }
                    : selectedProject,
            }))
            message.success(accessType === 'INTERNAL' ? '已启用内部页面权限' : '已切换为外部应用')
        } catch (error) {
            message.error(error?.message || '访问类型保存失败')
        } finally {
            this.setState({ accessSavingId: null })
        }
    }

    changePortalVisible = async (project, portalVisible) => {
        this.setState(({ portalSavingIds }) => ({
            portalSavingIds: [...portalSavingIds, project.id],
        }))
        try {
            await saveVibeAppPortalVisible({ projectId: project.id, portalVisible })
            this.setState(({ apps, selectedProject }) => ({
                apps: apps.map(item => item.id === project.id ? { ...item, portalVisible } : item),
                selectedProject: selectedProject?.id === project.id
                    ? { ...selectedProject, portalVisible }
                    : selectedProject,
            }))
            message.success(portalVisible ? '已在Portal展示' : '已从Portal隐藏')
        } catch (error) {
            message.error(error?.message || 'Portal展示状态保存失败')
        } finally {
            this.setState(({ portalSavingIds }) => ({
                portalSavingIds: portalSavingIds.filter(id => id !== project.id),
            }))
        }
    }

    openPermissionDrawer = (project) => {
        this.setState({
            drawerVisible: true,
            selectedProject: project,
            routes: [],
            routeSyncPrompt: '',
            selectedRouteIds: [],
            routeError: '',
            subjectType: 'ALL',
            subjectId: undefined,
            includeChildren: true,
            optionError: '',
            auditLoaded: false,
            auditError: '',
            audits: [],
            auditPageNum: 1,
        }, () => {
            this.loadRoutes()
            this.loadGrantOptions()
        })
    }

    loadGrantOptions = async () => {
        if (this.state.users.length && this.state.departments.length) return
        this.setState({ optionLoading: true, optionError: '' })
        try {
            const [users, departments] = await Promise.all([
                getUserListForDropbox({ type: 0 }),
                getUserDeparts({}),
            ])
            this.setState({ users: users || [], departments: departments || [], optionLoading: false })
        } catch (error) {
            this.setState({
                optionLoading: false,
                optionError: error?.message || '授权对象加载失败',
            })
        }
    }

    loadRoutes = async () => {
        const projectId = this.state.selectedProject?.id
        if (!projectId) return
        this.setState({ routeLoading: true, routeError: '' })
        try {
            const result = await getVibePageAccessRoutes({ projectId })
            this.setState({
                routes: result?.routes || [],
                routeSyncPrompt: result?.routeSyncPrompt || '',
                selectedProject: { ...this.state.selectedProject, ...result },
                routeLoading: false,
                selectedRouteIds: [],
            })
        } catch (error) {
            this.setState({ routeLoading: false, routeError: error?.message || '页面路由加载失败' })
        }
    }

    copyRouteSyncPrompt = async () => {
        const { routeSyncPrompt } = this.state
        if (!routeSyncPrompt) {
            message.warning('路由同步提示词尚未生成，请重新加载后再试')
            return
        }
        if (!navigator?.clipboard?.writeText) {
            message.warning('当前浏览器不支持自动复制，请升级浏览器后再试')
            return
        }
        try {
            await navigator.clipboard.writeText(routeSyncPrompt)
            message.success('路由同步提示词已复制，请发送给业务伙伴在项目 Codex 中执行')
        } catch (error) {
            message.error('提示词复制失败，请检查浏览器剪贴板权限')
        }
    }

    loadAudit = async (pageNum = this.state.auditPageNum) => {
        const projectId = this.state.selectedProject?.id
        if (!projectId) return
        this.setState({ auditLoading: true, auditError: '' })
        try {
            const result = await getVibePageAccessAudit({
                projectId,
                pageNum,
                pageSize: this.state.auditPageSize,
            })
            this.setState({
                audits: result?.list || [],
                auditTotal: result?.total || 0,
                auditPageNum: pageNum,
                auditLoaded: true,
                auditLoading: false,
            })
        } catch (error) {
            this.setState({
                auditLoading: false,
                auditLoaded: true,
                auditError: error?.message || '操作记录加载失败',
            })
        }
    }

    changeSubjectType = (subjectType) => {
        this.setState({ subjectType, subjectId: undefined, includeChildren: true })
    }

    buildPermissionRequest = (granted, routeIds, permission) => {
        const subjectType = permission?.subjectType || this.state.subjectType
        return {
            projectId: this.state.selectedProject.id,
            routeIds,
            subjectType,
            subjectId: subjectType === 'ALL' ? '' : (permission?.subjectId || this.state.subjectId),
            includeChildren: subjectType === 'DEPARTMENT'
                ? (permission ? !!permission.includeChildren : this.state.includeChildren)
                : false,
            granted,
        }
    }

    grantSelectedRoutes = async () => {
        const { selectedRouteIds, subjectType, subjectId } = this.state
        if (!selectedRouteIds.length) {
            message.warning('请先选择需要授权的页面')
            return
        }
        if (subjectType !== 'ALL' && !subjectId) {
            message.warning(subjectType === 'USER' ? '请选择员工' : '请选择部门')
            return
        }
        this.setState({ permissionSaving: true })
        try {
            const result = await saveVibePagePermission(
                this.buildPermissionRequest(true, selectedRouteIds)
            )
            message.success(`授权完成，更新 ${result?.changedCount || 0} 个页面`)
            await this.loadRoutes()
            if (this.state.auditLoaded) this.loadAudit(1)
        } catch (error) {
            message.error(error?.message || '权限保存失败')
        } finally {
            this.setState({ permissionSaving: false })
        }
    }

    revokePermission = (route, permission) => {
        Modal.confirm({
            title: '撤销页面权限',
            content: `确认撤销“${permission.subjectName || permission.subjectId || '全部员工'}”对“${route.routeName || route.pathPattern}”的访问权限？`,
            okText: '撤销',
            okButtonProps: { danger: true },
            cancelText: '取消',
            onOk: async () => {
                try {
                    await saveVibePagePermission(
                        this.buildPermissionRequest(false, [route.id], permission)
                    )
                    message.success('权限已撤销')
                    await this.loadRoutes()
                    if (this.state.auditLoaded) this.loadAudit(1)
                } catch (error) {
                    message.error(error?.message || '权限撤销失败')
                    return Promise.reject(error)
                }
            },
        })
    }

    renderSubjectSelector = () => {
        const {
            subjectType,
            subjectId,
            includeChildren,
            users,
            departments,
            optionLoading,
            optionError,
        } = this.state
        if (subjectType === 'ALL') {
            return <Alert type="info" showIcon message="授权后，所有已登录员工都可以访问选中的页面" />
        }
        if (optionError) {
            return (
                <Alert
                    type="error"
                    showIcon
                    message={optionError}
                    action={<Button size="small" onClick={this.loadGrantOptions}>重新加载</Button>}
                />
            )
        }
        if (subjectType === 'USER') {
            return (
                <Select
                    className="vibe-access-subject-select"
                    showSearch
                    allowClear
                    loading={optionLoading}
                    value={subjectId}
                    placeholder="搜索并选择员工"
                    optionFilterProp="children"
                    onChange={value => this.setState({ subjectId: value })}
                >
                    {users.map(user => (
                        <Select.Option key={user.USER_ID} value={user.USER_ID}>
                            {user.USER_NICK || user.USER_NAME || user.USER_ID}
                        </Select.Option>
                    ))}
                </Select>
            )
        }
        return (
            <Space className="vibe-access-department-row" size={16}>
                <Select
                    className="vibe-access-subject-select"
                    showSearch
                    allowClear
                    loading={optionLoading}
                    value={subjectId}
                    placeholder="搜索并选择部门"
                    optionFilterProp="children"
                    onChange={value => this.setState({ subjectId: value })}
                >
                    {departments.map(department => (
                        <Select.Option key={department.id} value={String(department.id)}>
                            {department.name || department.deptName || department.id}
                        </Select.Option>
                    ))}
                </Select>
                <Space>
                    <Switch
                        checked={includeChildren}
                        onChange={checked => this.setState({ includeChildren: checked })}
                    />
                    <Text>包含下级部门</Text>
                </Space>
            </Space>
        )
    }

    renderPermissions = (route) => {
        const permissions = route.permissions || []
        if (!permissions.length) return <Text type="secondary">尚未授权</Text>
        return (
            <Space size={[4, 6]} wrap>
                {permissions.map(permission => {
                    const meta = SUBJECT_META[permission.subjectType] || SUBJECT_META.USER
                    const name = permission.subjectName || permission.subjectId || meta.text
                    const suffix = permission.subjectType === 'DEPARTMENT' && permission.includeChildren
                        ? '（含下级）' : ''
                    return (
                        <Tag
                            key={permission.id}
                            color={meta.color}
                            closable
                            onClose={event => {
                                event.preventDefault()
                                this.revokePermission(route, permission)
                            }}
                        >
                            {name}{suffix}
                        </Tag>
                    )
                })}
            </Space>
        )
    }

    appColumns = () => [
        {
            title: '应用',
            dataIndex: 'projectName',
            width: 260,
            render: (value, record) => (
                <div className="vibe-access-app-cell">
                    <Text strong>{value || record.projectSlug}</Text>
                    <Text type="secondary">{record.projectSlug}</Text>
                </div>
            ),
        },
        {
            title: '负责人',
            dataIndex: 'ownerUserNick',
            width: 150,
            render: (value, record) => value || record.ownerUserName || record.ownerUserId || '-',
        },
        {
            title: '访问地址',
            dataIndex: 'publicUrl',
            ellipsis: true,
            render: value => value ? <a href={value} target="_blank" rel="noopener noreferrer">{value}</a> : '-',
        },
        {
            title: '状态',
            dataIndex: 'status',
            width: 110,
            render: value => {
                const meta = STATUS_META[value] || { color: 'default', text: value || '未知' }
                return <Tag color={meta.color}>{meta.text}</Tag>
            },
        },
        {
            title: '访问类型',
            dataIndex: 'accessType',
            width: 155,
            render: (value, record) => (
                <Select
                    size="small"
                    value={(value || 'INTERNAL').toUpperCase()}
                    loading={this.state.accessSavingId === record.id}
                    disabled={this.state.accessSavingId === record.id}
                    onChange={accessType => this.changeAccessType(record, accessType)}
                    style={{ width: 126 }}
                >
                    <Select.Option value="INTERNAL">内部应用</Select.Option>
                    <Select.Option value="EXTERNAL">外部应用</Select.Option>
                </Select>
            ),
        },
        {
            title: 'Portal展示',
            dataIndex: 'portalVisible',
            width: 130,
            render: (value, record) => {
                const saving = this.state.portalSavingIds.includes(record.id)
                return (
                    <Switch
                        checked={Boolean(value)}
                        checkedChildren="显示"
                        unCheckedChildren="隐藏"
                        loading={saving}
                        disabled={saving}
                        onChange={portalVisible => this.changePortalVisible(record, portalVisible)}
                    />
                )
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            fixed: 'right',
            render: (_, record) => (
                <Button type="link" icon={<LockOutlined />} onClick={() => this.openPermissionDrawer(record)}>
                    页面权限
                </Button>
            ),
        },
    ]

    routeColumns = () => [
        {
            title: '页面',
            dataIndex: 'routeName',
            width: 190,
            render: (value, record) => (
                <div className="vibe-access-route-cell">
                    <Text strong>{value || record.routeKey}</Text>
                    <Text type="secondary">{record.routeKey}</Text>
                </div>
            ),
        },
        {
            title: '访问路径',
            dataIndex: 'pathPattern',
            width: 210,
            render: value => <Text code>{value}</Text>,
        },
        {
            title: '当前授权',
            key: 'permissions',
            render: (_, route) => this.renderPermissions(route),
        },
    ]

    auditColumns = () => [
        {
            title: '页面',
            dataIndex: 'routeName',
            width: 170,
            render: (value, record) => value || record.pathPattern || record.routeKey || '-',
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: 88,
            render: value => <Tag color={value === 'GRANT' ? 'green' : 'red'}>{value === 'GRANT' ? '授权' : '撤销'}</Tag>,
        },
        {
            title: '授权对象',
            key: 'subject',
            render: (_, record) => {
                const meta = SUBJECT_META[record.subjectType] || { text: record.subjectType }
                const subjectName = record.subjectName || record.subjectId
                return record.subjectType === 'ALL' ? meta.text : `${meta.text}：${subjectName}`
            },
        },
        {
            title: '操作人',
            dataIndex: 'operatorName',
            width: 130,
            render: (value, record) => value || record.operatorUserId,
        },
        {
            title: '操作时间',
            dataIndex: 'createdAt',
            width: 170,
        },
    ]

    renderPermissionDrawer = () => {
        const {
            drawerVisible,
            selectedProject,
            routeLoading,
            routeError,
            routes,
            routeSyncPrompt,
            selectedRouteIds,
            subjectType,
            permissionSaving,
            auditLoaded,
            auditLoading,
            auditError,
            audits,
            auditTotal,
            auditPageNum,
            auditPageSize,
        } = this.state
        return (
            <Drawer
                className="vibe-access-drawer"
                width="min(900px, 92vw)"
                title={selectedProject ? `页面权限 · ${selectedProject.projectName}` : '页面权限'}
                open={drawerVisible}
                destroyOnClose
                onClose={() => this.setState({ drawerVisible: false })}
            >
                <div className="vibe-access-project-summary">
                    <div>
                        <Text type="secondary">应用标识</Text>
                        <Text strong>{selectedProject?.projectSlug || '-'}</Text>
                    </div>
                    <div>
                        <Text type="secondary">访问类型</Text>
                        <Tag color={selectedProject?.accessType === 'EXTERNAL' ? 'orange' : 'blue'}>
                            {selectedProject?.accessType === 'EXTERNAL' ? '外部应用' : '内部应用'}
                        </Tag>
                    </div>
                    <div>
                        <Text type="secondary">已登记页面</Text>
                        <Text strong>{routes.length}</Text>
                    </div>
                </div>

                {selectedProject?.accessType === 'EXTERNAL' && (
                    <Alert
                        className="vibe-access-drawer-alert"
                        type="warning"
                        showIcon
                        message="当前为外部应用，Gateway 不执行内部页面权限；已有配置会保留。"
                    />
                )}

                <Tabs
                    defaultActiveKey="permissions"
                    onChange={key => {
                        if (key === 'audit' && !auditLoaded) this.loadAudit(1)
                    }}
                >
                    <TabPane tab={<span><SafetyCertificateOutlined />权限配置</span>} key="permissions">
                        <Card className="vibe-access-route-sync-card" size="small" bordered={false}>
                            <div className="vibe-access-route-sync-content">
                                <div>
                                    <Text strong>让业务项目同步页面路由</Text>
                                    <Text type="secondary">
                                        {routes.length
                                            ? '业务项目新增、删除或修改页面后，将提示词发给业务伙伴重新执行。'
                                            : '当前还没有登记页面。将提示词发给业务伙伴，在项目 Codex 中分析页面、整理清单并上报。'}
                                    </Text>
                                </div>
                                <Button
                                    type={routes.length ? 'default' : 'primary'}
                                    icon={<CopyOutlined />}
                                    loading={routeLoading}
                                    disabled={!routeSyncPrompt}
                                    onClick={this.copyRouteSyncPrompt}
                                >
                                    复制路由同步提示词
                                </Button>
                            </div>
                        </Card>
                        <Card className="vibe-access-grant-card" size="small" bordered={false}>
                            <div className="vibe-access-grant-heading">
                                <div>
                                    <Text strong>批量授权</Text>
                                    <Text type="secondary">已选择 {selectedRouteIds.length} 个页面</Text>
                                </div>
                                <Radio.Group value={subjectType} onChange={event => this.changeSubjectType(event.target.value)}>
                                    <Radio.Button value="ALL">全部员工</Radio.Button>
                                    <Radio.Button value="USER">指定员工</Radio.Button>
                                    <Radio.Button value="DEPARTMENT">指定部门</Radio.Button>
                                </Radio.Group>
                            </div>
                            <div className="vibe-access-grant-actions">
                                {this.renderSubjectSelector()}
                                <Button
                                    type="primary"
                                    icon={<SafetyCertificateOutlined />}
                                    loading={permissionSaving}
                                    onClick={this.grantSelectedRoutes}
                                >
                                    授权选中页面
                                </Button>
                            </div>
                        </Card>

                        {routeError && <Alert className="vibe-access-drawer-alert" type="error" showIcon message={routeError} />}
                        <Table
                            rowKey="id"
                            size="middle"
                            loading={routeLoading}
                            dataSource={routes}
                            columns={this.routeColumns()}
                            pagination={false}
                            scroll={{ x: 760 }}
                            rowSelection={{
                                selectedRowKeys: selectedRouteIds,
                                onChange: keys => this.setState({ selectedRouteIds: keys }),
                            }}
                            locale={{ emptyText: <Empty description="尚未同步页面路由" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                        />
                    </TabPane>
                    <TabPane tab={<span><AuditOutlined />操作记录</span>} key="audit">
                        {auditError && (
                            <Alert
                                className="vibe-access-drawer-alert"
                                type="error"
                                showIcon
                                message={auditError}
                                action={<Button size="small" onClick={() => this.loadAudit(auditPageNum)}>重新加载</Button>}
                            />
                        )}
                        <Table
                            rowKey="id"
                            size="middle"
                            loading={auditLoading}
                            dataSource={audits}
                            columns={this.auditColumns()}
                            pagination={false}
                            scroll={{ x: 760 }}
                            locale={{ emptyText: <Empty description="还没有权限变更记录" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                        />
                        {auditTotal > auditPageSize && (
                            <div className="vibe-access-audit-pagination">
                                <Pagination
                                    current={auditPageNum}
                                    pageSize={auditPageSize}
                                    total={auditTotal}
                                    showSizeChanger={false}
                                    onChange={page => this.loadAudit(page)}
                                />
                            </div>
                        )}
                    </TabPane>
                </Tabs>
            </Drawer>
        )
    }

    render() {
        const { loading, listError, apps, total, pageNum, pageSize, keyword, status } = this.state
        return (
            <div className="vibe-access-page">
                <div className="vibe-access-heading">
                    <div>
                        <Title level={3}>Vibe 页面权限</Title>
                        <Text type="secondary">管理内部应用的页面登记和员工访问范围</Text>
                    </div>
                    <Button icon={<ReloadOutlined />} onClick={this.loadApps}>刷新</Button>
                </div>

                <Card bordered={false} className="vibe-access-card">
                    <div className="vibe-access-toolbar">
                        <Space size={12} wrap>
                            <Input
                                value={keyword}
                                allowClear
                                prefix={<SearchOutlined />}
                                placeholder="搜索应用名称、标识或负责人"
                                style={{ width: 300 }}
                                onChange={event => this.setState({ keyword: event.target.value })}
                                onPressEnter={() => this.setState({ pageNum: 1 }, this.loadApps)}
                            />
                            <Select
                                allowClear
                                value={status}
                                placeholder="全部状态"
                                style={{ width: 140 }}
                                onChange={value => this.setState({ status: value, pageNum: 1 }, this.loadApps)}
                            >
                                <Select.Option value="ready">运行中</Select.Option>
                                <Select.Option value="provisioning">接入中</Select.Option>
                                <Select.Option value="failed">接入失败</Select.Option>
                                <Select.Option value="disabled">已停用</Select.Option>
                            </Select>
                            <Button type="primary" icon={<SearchOutlined />} onClick={() => this.setState({ pageNum: 1 }, this.loadApps)}>
                                查询
                            </Button>
                            <Button onClick={this.resetSearch}>重置</Button>
                        </Space>
                        <Text type="secondary">共 {total} 个应用</Text>
                    </div>

                    {listError && <Alert className="vibe-access-list-alert" type="error" showIcon message={listError} />}
                    <Spin spinning={loading}>
                        <Table
                            rowKey="id"
                            dataSource={apps}
                            columns={this.appColumns()}
                            pagination={false}
                            scroll={{ x: 980 }}
                            locale={{ emptyText: <Empty description="没有符合条件的应用" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
                        />
                    </Spin>
                    {total > pageSize && (
                        <div className="vibe-access-pagination">
                            <Pagination
                                current={pageNum}
                                pageSize={pageSize}
                                total={total}
                                showSizeChanger
                                showQuickJumper
                                showTotal={value => `共 ${value} 条`}
                                onChange={(nextPage, nextSize) => this.setState({
                                    pageNum: nextSize === pageSize ? nextPage : 1,
                                    pageSize: nextSize,
                                }, this.loadApps)}
                            />
                        </div>
                    )}
                </Card>
                {this.renderPermissionDrawer()}
            </div>
        )
    }
}
